export default "__VITE_ASSET__KKd1Al2V__"